<template>
  <div class="bookmark-list-layer"
       :class="`${ 'mode-' + mode }`">
    <div v-if="mode === 'targeting'"
         class="layer-title">
      <h4>{{ $t('journey.targeting.layer.title') }}</h4>
      <p>{{ $t('journey.targeting.layer.description') }}</p>
    </div>
    <div v-else-if="mode === 'manage'"
         class="layer-title">
      <h4>{{ $t('bookmark.unable') }}</h4>
      <p>{{ $t('bookmark.unableInfo') }}</p>
    </div>
    <div v-else-if="mode === 'guide'"
         class="layer-title">
      <h4>{{ $t('journey.targeting.layer.title') }}</h4>
    </div>

    <div v-if="mode !== 'guide'"
         class="list-type-selector">
      <input type="checkbox" id="bookmark-list-type-selector"
             v-model="isCardTypeList" />
      <label for="bookmark-list-type-selector">
        <span>{{ isCardTypeList ? 'Card' : 'List'}} type</span>
      </label>
    </div>

    <div v-if="mode === 'guide'"
         class="guide-box">
      <h5 class="ment" v-html="$t('journey.targeting.layer.bookmarkGuide')" />
      <ol class="how-to">
        <li class="how-1">1. {{ $t('journey.targeting.layer.bookmarkGuideFromNodeReport') }}</li>
        <li class="how-2">2. {{ $t('journey.targeting.layer.bookmarkGuideFromRanking') }}</li>
      </ol>
    </div>
    <div v-else
         class="list-box"
         :class="`${ isCardTypeList ? 'type-card' : 'type-list' }`">
      <div class="list-wrap type-card"
           :class="{
             'data-added': !!listDataArray
           }">
        <ba-bookmark-card-list v-if="listDataArray"
                               ref="listTypeCard"
                               :mode="mode"
                               :listDataArray="listDataArray"
                               :selectedId="selectedId"
                               :defaultSlideIndex="selectedDeviceIndex"
                               :defaultThumbnails="defaultThumbnails"
                               :isCustomNode="isCustomNode"
                               @onSelect="selectNode"
                               @onToggleBookmark="toggleBookmark"
                               @onScroll="onCartListScroll" />
      </div>
      <div class="list-wrap type-list"
           :class="{
             'data-added': !!listDataArray
           }">
        <ba-bookmark-list v-if="listDataArray"
                          ref="listTypeList"
                          :mode="mode"
                          :listDataArray="listDataArray"
                          :selectedId="selectedId"
                          :selectedDevice="journeyOptions.device || 'desktop'"
                          :isCustomNode="isCustomNode"
                          @onSelect="selectNode"
                          @onToggleBookmark="toggleBookmark" />
      </div>
    </div>

    <div v-if="mode === 'targeting'"
         class="button-area submit-button">
      <ui-button :primary="true"
                 :size="'large'"
                 :iconName="isBlank ? 'icon--new-window-white' : 'icon--arrow-body-right-white'"
                 :disabled="partiallyLoading"
                 @click="onTargetingButtonClick">
        {{ $t('journey.targeting.targetingButton') }}
      </ui-button>
    </div>

    <div v-if="mode === 'manage' || mode === 'guide'"
         class="button-area close-button">
      <ui-button :size="'large'"
                 @click="onClickCloseButton">
        {{ $t('common.confirm') }}
      </ui-button>
    </div>

    <button v-if="mode === 'targeting'"
            type="button"
            class="close-layer"
            @click="onClickCloseButton">
      <i class="icon icon--close-size16" />
      {{ $t('common.close') }}
    </button>

    <transition name="fade">
      <div class="partially-loading"
           v-if="partiallyLoading">
        <ba-loading :showLoadingText="true" />
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { EventBus } from '@/libs/event-bus'
import { getS3Url } from '@/libs/utils'

import { getBookmarkList, updateBookmark } from '@/api/ranking'
import BaLoading from '@/components/ui/ba/Loading'
import UiButton from '@/components/ui/UiButton'

import BaBookmarkList from '@/components/targeting/BookmarkList'
import BaBookmarkCardList from '@/components/targeting/BookmarkCardList'
import { isInIframe } from '@/libs/auth-helper'

export default {
  name: 'BaBookmarkListLayer',
  components: {
    BaLoading,
    UiButton,
    BaBookmarkList,
    BaBookmarkCardList
  },
  props: {
    mode: {
      type: String,
      default: 'targeting',
      validator: (value) => {
        return ['targeting', 'manage', 'guide'].indexOf(value) > -1
      }
    },
    selectedUrlId: {
      type: Number,
      default: -1
    },
    isBlank: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      listData: null,
      listDataArray: null,

      selectedId: -1,

      partiallyLoading: false,

      defaultThumbnails: {},

      selectedDeviceIndex: 0,

      isCardTypeList: true
    }
  },
  computed: {
    ...mapState([
      'planData',
      'journeyOptions',
      'journeyPeriod'
    ]),
    isCustomNode () {
      return this.journeyOptions.isCustomNode
    },
    reportView () {
      return this.$route.name
    },
    dataOption () {
      const dataOption = {
        sid: this.journeyOptions.sid,
        isCustomNode: this.journeyOptions.isCustomNode,
        matchType: this.journeyOptions.matchType
      }
      if (this.reportView === 'journey') {
        if (this.journeyOptions.subSid) {
          dataOption.subSid = this.journeyOptions.subSid
          dataOption.firstPathname = this.journeyOptions.firstPath
        }
      }
      return dataOption
    }
  },
  watch: {
    isCardTypeList (value) {
      const $targetComponent = this.$refs[value ? 'listTypeCard' : 'listTypeList']
      if ($targetComponent) {
        $targetComponent.$refs.scrollBox.hideTrack()
        setTimeout(() => {
          $targetComponent.$refs.scrollBox.refresh()
          $targetComponent.$refs.scrollBox.showTrack()
        }, 300)
      }
    }
  },
  created () {
    this.partiallyLoading = this.mode !== 'guide'
  },
  mounted () {
    if (this.mode !== 'guide') {
      this.loadList()
    }

    this._$cardTypeList = this.$el.querySelector('.list-wrap.type-card')
  },
  beforeDestroy () {
  },
  methods: {
    ...mapMutations([
      'setJourneyTargetingOptions',
      'setBookmarkListLayerOptions'
    ]),
    ...mapActions([
      'storeBookmarkCount'
    ]),

    loadList () {
      this.partiallyLoading = true

      getBookmarkList(this.dataOption, true)
        .then(response => {
          this.listData = response
          this.listDataCache = JSON.parse(JSON.stringify(response))
          this.partiallyLoading = false
          this.onLoadList()
        })
        .catch((e) => {
          EventBus.$emit('onError')
          this.apiLoading = false
        })
    },
    onLoadList () {
      const journeyOptionsDomain = this.journeyOptions.domain
      const journeyOptionsDevice = this.journeyOptions.device
      const journeyOptionsMatchType = this.journeyOptions.matchType
      const a = document.createElement('a')
      const dataArray = []

      let forceDisplaySubdomain = false
      for (let id in this.listData) {
        if (this.listData[id] && !this.isCustomNode) {
          a.href = this.listData[id].url
          if (a.hostname !== journeyOptionsDomain) {
            const subDomain = a.hostname.replace('.' + journeyOptionsDomain, '')
            if (subDomain.split('.').length === 1 && subDomain.split('.')[0] !== 'www') {
              forceDisplaySubdomain = true
              break
            }
          }
        }
      }

      const deviceList = ['desktop', 'tablet', 'phone']
      this.selectedDeviceIndex = deviceList.indexOf(journeyOptionsDevice)

      for (let id in this.listData) {
        if (!this.listData[id]) {
          continue
        }
        const item = this.listData[id]
        item._id = isNaN(id) ? id : parseInt(id)

        a.href = item.url

        item._domain = forceDisplaySubdomain ? a.host : journeyOptionsDomain
        item._path = a.pathname
        if (journeyOptionsMatchType === 'exact') {
          const pathStartIdx = a.href.indexOf(a.host) + a.host.length
          item._path = a.href.slice(pathStartIdx)
        }
        item._path = decodeURI(item._path)
        if (item.imagePath) {
          item._thumbnailsMap = {}
          deviceList.forEach((device, index) => {
            item._thumbnailsMap[device] = item.imagePath[device] ? getS3Url(item.imagePath[device]) : null
            if (!this.defaultThumbnails[device] && item._thumbnailsMap[device]) {
              this.defaultThumbnails[device] = item._thumbnailsMap[device]
            }
          })
        }

        dataArray.push(item)
      }

      dataArray.sort((a, b) => {
        if (a._domain > b._domain) {
          return 1
        }
        if (a._domain < b._domain) {
          return -1
        }
        if (a._path > b._path) {
          return 1
        }
        if (a._path < b._path) {
          return -1
        }
        return 0
      })

      this.listDataArray = dataArray

      let selectedId = -1
      if (dataArray.length > 0) {
        if (this.mode === 'targeting') {
          if (dataArray.length > 1 && this.selectedUrlId > -1 && this.listData[this.selectedUrlId]) {
            selectedId = this.selectedUrlId
          } else {
            selectedId = this.listData[dataArray[0]._id]._id
          }
        }
      }

      this.$nextTick(() => {
        const $listItems = [].slice.call(this.$el.querySelectorAll('.list-wrap.type-list ul > li'))
        $listItems.forEach(($node, index) => {
          dataArray[index]._top = $node.offsetTop
          dataArray[index]._height = $node.offsetHeight
        })
        this.selectedId = selectedId
      })
    },
    selectNode (id) {
      if (this.mode === 'targeting') {
        this.selectedId = id
      }
    },
    toggleBookmark (id) {
      if (this.mode === 'manage') {
        const nodeData = this.listData[id]
        this.$set(nodeData, '_loading', true)
        const bookmark = {
          sid: this.journeyOptions.sid,
          gUrlId: id,
          addBookmark: !nodeData.bookmark
        }
        if (this.journeyOptions.matchType === 'exact') {
          bookmark.url = nodeData.url
        }
        if (this.journeyOptions.subSid) {
          bookmark.subSid = this.journeyOptions.subSid
        }

        const updatedKey = this.journeyOptions.matchType === 'exact' ? nodeData.url : id

        updateBookmark(bookmark, true)
          .then(response => {
            if (response.updated) {
              EventBus.$emit('updateBookmark', updatedKey, response.bookmark)
              this.$set(nodeData, 'bookmark', response.bookmark)
              this.storeBookmarkCount()
            }
            this.$set(nodeData, '_loading', false)
          })
          .catch((e) => {
            EventBus.$emit('onError')
          })
      }
    },
    onTargetingButtonClick () {
      if (this.selectedId !== -1) {
        const currentPage = this.$router.history.current.name
        const selected = this.listData[this.selectedId]
        let targetNodeKey = this.isCustomNode ? this.selectedId : null
        if (this.journeyOptions.matchType === 'exact' && selected) {
          targetNodeKey = selected.url
        }

        if (currentPage !== 'journey') {
          const newWindow = window.open(location.href.replace(/\/tool\/[^?]+\?/, '/tool/journey?'), isInIframe() ? '_self' : '_blank')
          newWindow._journeyOptionsFromParent = { ...this.journeyOptions }
          newWindow._journeyPeriodFromParent = { ...this.journeyPeriod }
          newWindow._journeyTargetingOptionsFromParent = {
            direction: 'backward',
            gUrlId: !this.isCustomNode ? selected.gUrlId : null,
            nodeData: this.listDataCache[this.selectedId],
            isCustomNode: this.journeyOptions.isCustomNode,
            targetNodeKey
          }
        } else {
          const targetData = {
            direction: 'backward',
            pageFrom: currentPage,
            gUrlId: !this.isCustomNode ? selected.gUrlId : null,
            nodeData: this.listDataCache[this.selectedId],
            isCustomNode: this.journeyOptions.isCustomNode,
            targetNodeKey
          }

          this.setJourneyTargetingOptions(targetData)
          this.setBookmarkListLayerOptions(false)
        }
      }
    },
    onClickCloseButton () {
      this.partiallyLoading = true
      setTimeout(function () {
        this.setBookmarkListLayerOptions(false)
        this.partiallyLoading = false
      }.bind(this), 300)
    },
    onCartListScroll (scrollTop, scrollHeight, scrollableTop) {
      this._$cardTypeList.classList[scrollTop > 5 ? 'add' : 'remove']('shadow-top')
      this._$cardTypeList.classList[scrollTop < scrollableTop - 5 ? 'add' : 'remove']('shadow-bottom')
    }
  }
}
</script>

<style lang="scss" scoped>
.bookmark-list-layer {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 960px;
  height: 600px;
  border-radius: 14px;
  background-color: #fff;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  transform: translate(-50%, -50%);

  &.mode-targeting,
  &.mode-guide {
    .layer-title {
      padding-left: 66px;
      background: url('../../assets/img/targeting/icon--targeting.svg') no-repeat 0 0 / 40px;

      &:before {
        left: 50px;
      }
    }
  }
  &.mode-targeting {
    .list-box {
      &.type-list.with-need-more {
        bottom: 223px;
      }
    }
  }

  &.mode-guide {
    .layer-title {
      h4 {
        padding-top: 12px;
      }
    }
  }

  .layer-title {
    position: absolute;
    left: 30px;
    top: 30px;
    height: 40px;
    padding-left: 71px;
    background: url('../../assets/img/common/icon--alert.svg') no-repeat 2px -6px / 50px;

    &:before {
      position: absolute;
      left: 55px;
      top: 1px;
      bottom: 2px;
      content: '';
      border-left: 1px solid #d7d7d7;
    }

    h4 {
      font-size: 15px;
      font-weight: 500;
      color: #2f2f2f;
      line-height: 1;
    }

    p {
      font-size: 12px;
      color: #767676;
      line-height: 1;
      margin-top: 12px;
    }
  }

  .list-type-selector {
    position: absolute;
    right: 40px;
    top: 32px;
    width: 90px;
    height: 32px;
    text-indent: -999em;
    border: solid 1px #d7d7d7;
    border-radius: 18px;
    background-color: rgba(0, 0, 0, 0.06);
    box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.04);

    input {
      position: absolute;
      left: -999em;
    }

    label {
      width: 100%;
      height: 100%;
      border-radius: 16px;
      display: block;
      cursor: pointer;

      &:before {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        content: '';
        border-radius: inherit;
        background: url('../../assets/img/targeting/icon--list-type-card.svg') no-repeat 15px 6px,
                    url('../../assets/img/targeting/icon--list-type-list.svg') no-repeat 55px 6px;
        opacity: 0.3;
      }

      span {
        position: absolute;
        left: 0;
        top: 0;
        width: 50px;
        height: 32px;
        content: '';
        border-radius: inherit;
        background-color: #fff;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
        overflow: hidden;
        transition: transform 0.35s $ease-out-quart;

        &:before {
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 90px;
          content: '';
          border-radius: inherit;
          background: url('../../assets/img/targeting/icon--list-type-card.svg') no-repeat 15px 6px,
                      url('../../assets/img/targeting/icon--list-type-list.svg') no-repeat 55px 6px;
          transition: inherit;
        }
      }
    }

    input:not(:checked) + label {
      span {
        transform: translate3d(40px, 0, 0);

        &:before {
          transform: translate3d(-40px, 0, 0);
        }
      }
    }
  }

  .list-box {
    position: absolute;
    left: 30px;
    right: 30px;
    top: 127px;
    bottom: 30px;
    bottom: 88px;
    border-radius: 10px;
    background-color: #f4f4f4;
    z-index: 0;
    transition: background-color 0.3s, top 0.35s $ease-out-quart, bottom 0.35s $ease-out-quart;

    &.type-card {
      top: 100px;
      overflow: hidden;

      &:not(.with-need-more) {
        background-color: #bcbcbc;

        > .list-wrap {
          background-color: #bcbcbc;

          &:before,
          &:after {
            position: absolute;
            left: -10px;
            right: -10px;
            top: 0;
            height: 10px;
            content: '';
            background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.06) 14%, rgba(0, 0, 0, 0));
            z-index: 1;
            opacity: 0;
            transition: opacity 0.15s ease-out;
          }
          &:after {
            top: auto;
            bottom: 0;
            transform: scaleY(-1);
          }
          &.shadow-top:before,
          &.shadow-bottom:after {
            opacity: 1;
          }
        }
      }
    }
    & > .list-wrap:not(.data-added),
    &.type-card > .list-wrap.type-list,
    &.type-list > .list-wrap.type-card {
      opacity: 0;
      visibility: hidden;
      transition: 0.05s ease-out;
    }

    & /deep/ div.need-more {
      bottom: 0;
      transition: bottom 0.35s $ease-out-quart;
    }

    &.type-list {
      border: solid 1px #d7d7d7;

      &.with-need-more {
        bottom: 165px;
      }

      .list-wrap.type-list /deep/ .need-more {
        bottom: -120px;
      }
    }

    > .list-wrap {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      border-radius: inherit;
      background-color: #f4f4f4;
      transition: 0.3s 0.1s ease-out;
      transition-property: opacity, visibility;
    }
  }

  .guide-box {
    position: absolute;
    left: 130px;
    right: 130px;
    top: 97px;
    bottom: 0;
    z-index: 0;

    .ment {
      height: 69px;
      font-size: 18px;
      font-weight: 500;
      color: #444;
      line-height: 1.39;
      margin: 0 -32px;
      padding: 8px 0 0 76px;
      background: url('../../assets/img/targeting/img-targeting-guide-character.svg') no-repeat;
    }

    .how-to {
      position: absolute;
      left: 0;
      right: 0;
      top: 101px;
      bottom: 0;

      [class*="how-"] {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 304px;
        font-size: 14px;
        font-weight: 500;
        color: #ff5700;
        line-height: 1;
        text-align: center;
        background: no-repeat 0 32px / 304px auto;
      }

      .how-1 {
        left: 0;
        background-image: url('../../assets/img/targeting/img-bookmark-guide-1.png');
      }

      .how-2 {
        right: 0;
        background-image: url('../../assets/img/targeting/img-bookmark-guide-2.png');
      }
    }
  }

  .button-area {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 25px;
    text-align: center;

    button[type="button"] {
      padding-left: 25px;
      padding-right: 25px;

      &.use-icon {
        padding-left: 39px;

        & /deep/ .icon {
          left: 12px;
        }
      }
    }
  }

  .close-layer {
    position: absolute;
    right: 0;
    top: 0;
    width: 40px;
    height: 40px;
    text-indent: -999em;
    overflow: hidden;

    .icon {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .partially-loading {
    position: absolute;
    left: 0;
    right: 0;
    top: 80px;
    bottom: 80px;
    background-color: #fff;

    &.fade-leave-active,
    &.fade-enter-active {
      transition: opacity 0.3s ease;
      opacity: 1;
    }

    &.fade-enter,
    &.fade-leave-to {
      opacity: 0;
    }
  }
}
</style>
